import '../assets/css/style.css';
import feedbackVector from '../assets/images/feedback.webp'
import Footer from './Footer';
import Ratings from "./Ratings";
import TopNavbar from './TopNavbar';
import {useState} from 'react';
import { Helmet } from "react-helmet-async";
// import axios from 'axios';


const Feedback = () => {

    const [fullname, setFullname] = useState("");
    const [email, setEmail] = useState("");
    const [comment, setComment] = useState("");
    // const rating = localStorage.getItem("rating");
    
    // function handleSubmit(e) {
    //     e.preventDefault();
    //     const data = {
    //         Fullname:fullname,
    //         Email:email,
    //         Rating:rating,
    //         Comment:comment
    //     }
    //     axios.post('https://sheet.best/api/sheets/c6230704-223e-4cc5-b00a-ca297dd66690',data).then(response => {

    //         alert("Thank You for your Feedback.");
    //         setFullname('');
    //         setEmail('');
    //         setComment('');
    //     }).catch(error => {
    //         console.log(error);
    //     })
    // }

    return (
        <>
        <Helmet>
            <title>Feedback - Easy Data Structures</title>
            <meta name="description" content="Share your thoughts with us! Use the EasyDataStructures feedback page to send suggestions, report issues, and help us improve your learning experience." />
            <link rel="canonical" href="https://easydatastructures.com/feedback" />
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/",
            "logo": "https://easydatastructures.com/easyDS-easydatastructures-logo.webp",
            "sameAs": [
                "https://www.facebook.com/EasyDataStructures",
                "https://www.instagram.com/easydatastructures",
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "Person",
            "name": "Madan Lal",
            "url": "https://madanlal1.github.io/Profile-Portfolio/",
            "image": "https://avatars.githubusercontent.com/u/81483460?v=4",
            "sameAs": [
                "https://www.youtube.com/@visualhow",
                "https://www.linkedin.com/company/easydatastructures",
                "https://github.com/madanlal1",
                "https://easydatastructures.com/"
            ]  
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "Easy Data Structures",
            "url": "https://easydatastructures.com/feedback/",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://easydatastructures.com/feedback/search?q=keyword{search_term_string}",
                "query-input": "required name=search_term_string"
            }
            }
            )}
            </script>
            <script type="application/ld+json">{JSON.stringify(
            {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What is Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Easy Data Structures is an online platform that provides simple explanations, visuals, tutorials, and real-world examples of data structures and algorithms to help students and developers learn quickly."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Who can learn from Easy Data Structures?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The website is designed for beginners, computer science students, job seekers preparing for technical interviews, and developers who want to refresh their knowledge of data structures."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Are the tutorials suitable for coding interview preparation?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, the tutorials and examples on Easy Data Structures cover the core concepts frequently asked in technical interviews, including arrays, linked lists, stacks, queues, trees, graphs, and algorithms."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Is Easy Data Structures free to use?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, all the explanations and learning material on Easy Data Structures are freely available for students and developers."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Which data structures can I learn on this website?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "You can learn core data structures such as arrays, linked lists, stacks, queues, trees, heaps, hash tables, graphs, and more, along with visual examples and use cases."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Does Easy Data Structures offer real-world examples?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, each topic includes simple, real-world examples to help you understand how data structures are used in actual applications."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can beginners understand the explanations easily?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely. The content is written in simple language with diagrams and step-by-step explanations, making it ideal for beginners."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Do I need coding experience to start?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No prior coding experience is required. The website starts with the basics and gradually introduces you to more advanced concepts."
                    }
                }
                ]
            }
            )}
            </script>
        </Helmet>
        <TopNavbar/>

        <div className="row g-0 feedbackContainer">
            <div id="feedback-vector" className="col-xl-6 col-lg-6 col-md-5 col-sm-12">
                <img src={feedbackVector} alt="feedback-vector" width="100%"/>
            </div>
            
            <div id="feedback-form" className="col-xl-6 col-lg-6 col-md-7 col-sm-12">
                <form action="https://api.web3forms.com/submit" method="POST">

                <input type="hidden" name="access_key" value="05028b15-ca07-4ef5-9935-0a7b3bfd2ef8">
                
                </input>
                    <div className="form-group">
                        <label htmlFor="exampleFormControlInput1">Fullname</label>
                        <input type="text" name='fullname' onChange={e => setFullname(e.target.value)} value={fullname} className="form-control" id="exampleFormControlInput1" placeholder="Fullname" required/>
                    </div><br/>

                    <div className="form-group">
                        <label htmlFor="exampleFormControlInput2">Email address</label>
                        <input type="email" name='email' onChange={e => setEmail(e.target.value)} value={email} className="form-control" id="exampleFormControlInput2" placeholder="name@example.com" required/>
                    </div><br/>

                    <Ratings/><br/>

                    <div className="form-group">
                        <label htmlFor="exampleFormControlTextarea1">Comment</label>
                        <textarea className="form-control" name='Message' onChange={e => setComment(e.target.value)} value={comment} id="exampleFormControlTextarea1" rows="5" placeholder="Type your feedback here..." required></textarea>
                    </div><br/>

                    <button type="submit" className="btn btn-primary">Submit Feedback</button>
                    </form>
            </div>
        </div>

        <Footer/>
        </>
    )
}
export default Feedback;